import { useEffect } from "react";
import { META, SITE, setMetaTag } from "../site";

export default function useSiteMeta(lang, overrides = {}) {
  useEffect(() => {
    const m = { ...META[lang], ...overrides };
    const locale = lang === "pl" ? "pl_PL" : "en_GB";

    document.title = m.title;
    setMetaTag("name", "description", m.description);
    setMetaTag("property", "og:title", m.ogTitle || m.title);
    setMetaTag("property", "og:description", m.ogDescription || m.description);
    setMetaTag("property", "og:locale", locale);
    setMetaTag("name", "twitter:title", m.ogTitle || m.title);
    setMetaTag("name", "twitter:description", m.ogDescription || m.description);

    if (m.canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = m.canonical;
      setMetaTag("property", "og:url", m.canonical);
    } else {
      setMetaTag("property", "og:url", `${SITE.url}/`);
    }
  }, [lang, overrides]);
}